/** /comms/t/$threadId — route stub (Agent U1); component in t.$threadId.lazy.tsx. */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/comms/t/$threadId')({});
